import React, {ReactNode} from 'react';

import {prependAOrAn} from 'BenchlingUtil';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import {capitalize} from 'util/NameUtil';

interface Props {
  itemDescription: string;
  isPlural: boolean;
  nameTemplateAppliesToAllItems?: boolean; // Only has an effect when isPlural is true
  supportingInfo?: ReactNode;
}

export default function NameTemplateInfoBanner(props: Props): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.INFO}
      text={`${
        props.isPlural && !props.nameTemplateAppliesToAllItems
          ? `Some ${props.itemDescription}`
          : capitalize(props.itemDescription)
      } ${props.isPlural ? 'names' : 'name'} will be set using ${prependAOrAn(
        props.itemDescription
      )} name template.`}
      supportingInfo={props.supportingInfo}
    />
  );
}
